import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { storage } from '../utils/storage';
import ar from './locales/ar';
import ku from './locales/ku';

const resources = {
  ar: { translation: ar },
  ku: { translation: ku },
};

export const RTL_LANGS = ['ar', 'ku'];

const applyRtl = () => {
  document.documentElement.dir = 'rtl';
  document.documentElement.lang = i18n.language;
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'ku',
  fallbackLng: 'ku',
  supportedLngs: ['ar', 'ku'],
  compatibilityJSON: 'v4',
  interpolation: { escapeValue: false },
});

applyRtl();

storage.getItem('userLanguage').then((saved) => {
  if (RTL_LANGS.includes(saved)) {
    i18n.changeLanguage(saved);
  }
});

i18n.on('languageChanged', () => {
  applyRtl();
});

export default i18n;
